import React,{useEffect} from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import useSearchPagination from "./../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { checkAccessFn } from "../../../../utils/checkAccess";
import { useSelector,useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setBreadCrumb } from "../../../../store/userSlice";

export default function ListDataUser({
  list = [],
  editData,
  deleteData,
  loading,
  titles = [],
  addData,
}) {
  const dispatch = useDispatch()
  const { NoDataFound, Pagination, PaginationIndex, Search, currentList } =
    useSearchPagination(list);

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);
  
  const commonItems = [{ label: "ROLES AND PERMISSION", link: "" }];
  useEffect(() => {
    dispatch(setBreadCrumb(commonItems));
  }, []);

  return (
    <div className="pt-2 uppercase">
      <div className="flex flex-wrap gap-2 mb-1 items-center">
        {checkAccess("Roles and Permissions", "role-create") && (
          <Link to="/dashboard/roles-and-permission/create">
            <button
              className="p-2 bg-red text-white rounded-md uppercase"
              onClick={addData}
            >
              Add New Role +
            </button>
          </Link>
        )}
        <Search searchKey={["name"]} />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1 md:hidden block">{`Slide / scroll to right >`}</p>
      <div
        className={`grid justify-items-center grid-cols-table-3 auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
      >
        {titles.map((title, index) => (
          <p key={index} className="font-semibold uppercase">
            {title}
          </p>
        ))}
        {list.length <= 0 && (
          <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-3">
            <p>Loading</p>
            <CgSpinner className="animate-spin" />
          </div>
        )}
        <NoDataFound />
        {currentList.map((list, index) => (
          <React.Fragment key={index}>
            <PaginationIndex index={index} />
            <p>{list.name}</p>

            <div className="flex gap-3 min-w-fit ">
              {checkAccess("Roles and Permissions", "role-edit") ? (
                <button
                  className="p-1 px-2 rounded-md ring-1 ring-slate-600"
                  onClick={() => editData(list.id)}
                  disabled={loading.edit}
                >
                  {loading.edit && loading.loadingId === list.id ? (
                    <CgSpinner className="animate-spin mx-auto" />
                  ) : (
                    <CiEdit size={"1.4rem"} />
                  )}
                </button>
              ) : (
                <button className="p-1 px-2 rounded-md ring-1 ring-slate-300">
                  --
                </button>
              )}

              {checkAccess("Roles and Permissions", "role-delete") ? (
                <button
                  className="p-1 px-2 rounded-md ring-1 ring-red text-white bg-red"
                  onClick={() =>
                    deleteData((oldState) => ({ open: true, id: list.id }))
                  }
                  disabled={loading.delete}
                >
                  {loading.delete && loading.loadingId === list.id ? (
                    <CgSpinner className="animate-spin mx-auto" />
                  ) : (
                    <MdDeleteOutline size={"1.4rem"} />
                  )}
                </button>
              ) : (
                <button className="p-1 px-2 rounded-md ring-1 ">--</button>
              )}
            </div>
            <hr
              className={`border-[1.5px] border-slate-100  w-full col-span-3 `}
            />
          </React.Fragment>
        ))}
      </div>
      <Pagination />
    </div>
  );
}
